module.exports = "import React from 'react';\nimport { Jumbotron, Container } from 'reactstrap';\n\nconst Example = (props) => {\n  return (\n    <div>\n      <Jumbotron fluid>\n        <Container fluid>\n          <h1 className=\"display-3\">Fluid jumbotron</h1>\n          <p className=\"lead\">This is a modified jumbotron that occupies the entire horizontal space of its parent.</p>\n        </Container>\n      </Jumbotron>\n    </div>\n  );\n};\n\nexport default Example;\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/components/Jumbotron/JumbotronFluid.js
// module id = 411
// module chunks = 0